import { render, staticRenderFns } from "./PassportSettings.vue?vue&type=template&id=5cd6bbea&scoped=true"
import script from "./PassportSettings.vue?vue&type=script&lang=js"
export * from "./PassportSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd6bbea",
  null
  
)

export default component.exports